module.exports = __webpack_public_path__ + "img/Degrees-Distributions-300x300.39ad43bc.png";